// Dependancies
import { combineEpics } from "redux-observable";

// Epics

// standard task
import { undoCreateTextEpic } from "./undoCreateTextEpic";

export const textEpics = combineEpics(undoCreateTextEpic);
